'use client';

import React from 'react';

// Components
import IMagnifier from '@public/svg/i-magnifier.jsx';
import IClose from '@public/svg/i-x.jsx';

const Search = ({ onClear, inputClassName, ...props }) => {
  return (
    <div
      className="w-[210px] border-[0.5px] border-solid border-[#DEDFDE] flex items-center gap-1 rounded-[8px] bg-white p-2 
      dd2-xl:w-fit
      dd2-lg:w-full"
    >
      <IMagnifier />
      <input
        className={`text-[#686A68] text-[14px] font-satoshi w-full ${inputClassName}`}
        readOnly
        {...props}
      />
      {props.value && (
        <button
          onClick={onClear}
          className="rounded-[8px] flex items-center justify-center p-1 bg-[#F5F5F5] cursor-pointer dd2-xl:hidden"
        >
          <IClose />
        </button>
      )}
    </div>
  );
};

export default Search;
